(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyInvoiceInfo', CompanyInvoiceInfo);

    CompanyInvoiceInfo.$inject = ['$resource'];

    function CompanyInvoiceInfo($resource) {
        var resourceUrl = 'api/company-invoice-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
